/**
 * Menvora — delivery timeline (product.ads)
 * Pedido hoy (CDMX) · despacho +1–2 · pago/entrega +5–7 (promesa tienda).
 * Monta: en flujo bajo el CTA del buy box + arriba del form Releasit.
 * El float COD queda solo con timer + botón (sin timeline).
 *
 * Importante: no observar subtree del form ni reinsertar en loop.
 * Releasit re-renderiza si mutamos el interior del <form>.
 */
(function () {
  if (window.__menvoraDeliveryTimeline) return;
  window.__menvoraDeliveryTimeline = true;

  var TZ = 'America/Mexico_City';
  var MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  var SHIP_MIN = 1;
  var SHIP_MAX = 2;
  var DELIVER_MIN = 5;
  var DELIVER_MAX = 7;
  var inlineEl = null;
  var formEl = null;
  var formWatchTimer = 0;
  var formMountAttempts = 0;
  var MAX_FORM_MOUNTS = 3;

  function todayYmdCdmx() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    var out = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') out[parts[i].type] = parts[i].value;
    }
    return out.year + '-' + out.month + '-' + out.day;
  }

  function parseYmd(ymd) {
    var bits = String(ymd).split('-');
    return new Date(Date.UTC(+bits[0], +bits[1] - 1, +bits[2], 12, 0, 0));
  }

  function formatYmd(dt) {
    return (
      dt.getUTCFullYear() +
      '-' +
      String(dt.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(dt.getUTCDate()).padStart(2, '0')
    );
  }

  function addDays(ymd, n) {
    var dt = parseYmd(ymd);
    dt.setUTCDate(dt.getUTCDate() + n);
    return formatYmd(dt);
  }

  function dayMonth(ymd) {
    var dt = parseYmd(ymd);
    return dt.getUTCDate() + ' ' + MONTHS[dt.getUTCMonth()];
  }

  function rangeLabel(startYmd, endYmd) {
    var a = parseYmd(startYmd);
    var b = parseYmd(endYmd);
    var d1 = a.getUTCDate();
    var d2 = b.getUTCDate();
    var m1 = MONTHS[a.getUTCMonth()];
    var m2 = MONTHS[b.getUTCMonth()];

    if (m1 === m2 && a.getUTCFullYear() === b.getUTCFullYear()) {
      return d1 + '-' + d2 + ' ' + m1;
    }
    return d1 + ' ' + m1 + '–' + d2 + ' ' + m2;
  }

  function computeDates(anchorYmd) {
    var order = anchorYmd || todayYmdCdmx();
    var shipStart = addDays(order, SHIP_MIN);
    var shipEnd = addDays(order, SHIP_MAX);
    var deliverStart = addDays(order, DELIVER_MIN);
    var deliverEnd = addDays(order, DELIVER_MAX);
    return {
      order: order,
      orderLabel: dayMonth(order),
      shipLabel: rangeLabel(shipStart, shipEnd),
      deliverLabel: rangeLabel(deliverStart, deliverEnd),
      shipStart: shipStart,
      shipEnd: shipEnd,
      deliverStart: deliverStart,
      deliverEnd: deliverEnd,
    };
  }

  function fillLabels(root, dates) {
    if (!root || !dates) return;
    var order = root.querySelector('[data-mdt-step="order"]');
    var ship = root.querySelector('[data-mdt-step="ship"]');
    var deliver = root.querySelector('[data-mdt-step="deliver"]');
    if (order) order.textContent = 'Haz el pedido ' + dates.orderLabel;
    if (ship) ship.textContent = 'Enviamos ' + dates.shipLabel;
    if (deliver) deliver.textContent = 'Pago y entrega ' + dates.deliverLabel;
  }

  function cloneTimeline(placement) {
    var tpl = document.getElementById('menvora-delivery-timeline-tpl');
    if (!tpl || !tpl.content) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.classList.add('menvora-delivery-timeline--' + placement);
    node.setAttribute('data-menvora-delivery-timeline', placement);
    fillLabels(node, computeDates());
    return node;
  }

  function mountInline() {
    var home = document.querySelector('[data-menvora-delivery-timeline-home]');
    if (!home) return;

    var existing = home.querySelector('[data-menvora-delivery-timeline="inline"]');
    if (existing) {
      inlineEl = existing;
      return;
    }

    var node = cloneTimeline('inline');
    if (!node) return;
    home.appendChild(node);
    inlineEl = node;
  }

  /**
   * Reemplaza .rsi-form-navigation-wrapper (dentro de .rsi-form-content-wrapper).
   * No mutar el resto del form: evita el ciclo open/close de Releasit.
   */
  function mountForm() {
    var wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap) {
      formEl = null;
      formMountAttempts = 0;
      return false;
    }

    var existing = wrap.querySelector('[data-menvora-delivery-timeline="form"]');
    if (existing && existing.isConnected) {
      formEl = existing;
      return true;
    }

    var nav = wrap.querySelector(
      '.rsi-form-content-wrapper > .rsi-form-navigation-wrapper, .rsi-form-navigation-wrapper'
    );
    if (!nav || !nav.parentNode) return false;

    if (formMountAttempts >= MAX_FORM_MOUNTS) return false;
    formMountAttempts += 1;

    var node = cloneTimeline('form');
    if (!node) return false;

    try {
      if (!nav.parentNode || !nav.parentNode.contains(nav)) return false;
      nav.parentNode.replaceChild(node, nav);
    } catch (err) {
      return false;
    }
    formEl = node;
    return true;
  }

  function watchForm() {
    if (formWatchTimer) return;
    formWatchTimer = window.setInterval(function () {
      var wrap = document.getElementById('rsi_form_wrapper');
      if (!wrap) {
        formEl = null;
        formMountAttempts = 0;
        return;
      }
      var visible =
        wrap.getBoundingClientRect().height > 40 &&
        window.getComputedStyle(wrap).display !== 'none';
      if (!visible) return;

      if (mountForm() && formEl && formEl.isConnected) {
        // Ya montó con éxito en esta apertura; no seguir reintentando agresivo
        if (formMountAttempts >= 1 && formEl.isConnected) {
          /* keep watching in case wrapper is destroyed on close */
        }
      }
    }, 600);
  }

  function init() {
    if (!document.getElementById('menvora-delivery-timeline-tpl')) return;
    mountInline();
    watchForm();

    window.MenvoraDeliveryTimeline = {
      computeDates: computeDates,
      addDays: addDays,
      rangeLabel: rangeLabel,
      dayMonth: dayMonth,
      refresh: function (ymd) {
        var dates = computeDates(ymd);
        document.querySelectorAll('[data-menvora-delivery-timeline]').forEach(function (el) {
          fillLabels(el, dates);
        });
        return dates;
      },
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
